module.exports = __webpack_public_path__ + "static/media/desktop_locationpartners_logos.82cb9847.png";